import * as React from 'react';
import './resizer.scss';
import { cn } from '../../utils';

interface Props {
  minWidth: number;
}

export const useResizer = ({ minWidth }: Props) => {
  const resizerRef = React.useRef(null);
  const [isResizing, setIsResizing] = React.useState(false);
  const [resizerWidth, setResizerWidth] = React.useState(minWidth);

  const startResizing = React.useCallback(mouseDownEvent => {
    setIsResizing(true);
  }, []);

  const stopResizing = React.useCallback(() => {
    setIsResizing(false);
  }, []);

  const resize = React.useCallback(
    mouseMoveEvent => {
      if (isResizing) {
        setResizerWidth(
          mouseMoveEvent.clientX -
            resizerRef.current.getBoundingClientRect().left
        );
      }
    },
    [isResizing]
  );
  React.useEffect(() => {
    window.addEventListener('mousemove', resize);
    window.addEventListener('mouseup', stopResizing);
    return () => {
      window.removeEventListener('mousemove', resize);
      window.removeEventListener('mouseup', stopResizing);
    };
  }, [resize, stopResizing]);

  const Resizer = () => {
    return (
      <div
        className={cn(
          { 'app-sidebar-resizer': isResizing },
          'app-sidebar-resizer'
        )}
        onMouseDown={startResizing}
      />
    );
  };

  return { isResizing, Resizer, resizerWidth, resizerRef };
};
